import { render, staticRenderFns } from "./storeTransfer.vue?vue&type=template&id=2a86d692"
import script from "./storeTransfer.vue?vue&type=script&lang=js"
export * from "./storeTransfer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports